import { render, staticRenderFns } from "./EdicionPtiAgregarTratamiento.vue?vue&type=template&id=597eed4c&scoped=true"
import script from "./EdicionPtiAgregarTratamiento.vue?vue&type=script&lang=js"
export * from "./EdicionPtiAgregarTratamiento.vue?vue&type=script&lang=js"
import style0 from "./EdicionPtiAgregarTratamiento.vue?vue&type=style&index=0&id=597eed4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597eed4c",
  null
  
)

export default component.exports